// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/_index'
import { Route as IndexIndexRouteImport } from './routes/_index.index'
import { Route as IndexTemplatesRouteImport } from './routes/_index.templates'
import { Route as IndexSettingsRouteImport } from './routes/_index.settings'
import { Route as IndexLogRouteImport } from './routes/_index.log'

const IndexRoute = IndexRouteImport.update({
            id: '/_index',getParentRoute: () => rootRouteImport
          })
const IndexIndexRoute = IndexIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndexRoute
          })
const IndexTemplatesRoute = IndexTemplatesRouteImport.update({
            id: '/templates',path: '/templates',getParentRoute: () => IndexRoute
          })
const IndexSettingsRoute = IndexSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => IndexRoute
          })
const IndexLogRoute = IndexLogRouteImport.update({
            id: '/log',path: '/log',getParentRoute: () => IndexRoute
          })





const IndexRouteChildren = {
  IndexLogRoute: IndexLogRoute,IndexSettingsRoute: IndexSettingsRoute,IndexTemplatesRoute: IndexTemplatesRoute,IndexIndexRoute: IndexIndexRoute
}

const IndexRouteWithChildren = IndexRoute._addFileChildren(IndexRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)